export const NAME_REG_EXP = /^[A-Za-z0-9'_-\s]*$/;
export const NUMERIC_ONLY_REG_EXP = /^\d+$/;

export const MAX_FILE_SIZE = 33 * 1024 * 1024; // 33 MB in bytes
export const MAX_FILES_COUNT = 5;

export const NAME_MAX_LENGTH = 255;
export const NAME_MIN_LENGTH = 2;
export const DESCRIPTION_MAX_LENGTH = 150;
export const DESCRIPTION_MIN_LENGTH = 2;
export const MESSAGE_MAX_LENGTH = 2000;
export const MESSAGE_MIN_LENGTH = 2;
export const EXCLUDE_CYRILLIC_REG_EXP = /^[^\u0400-\u04FF]+$/;
export const PROFILE_ID_MAX_LENGTH = 255;

export const ALLOWED_EXTENSIONS = [
  'gif',
  'jpg',
  'jpeg',
  'png',
  'txt',
  'rtf',
  'pdf',
  'doc',
  'docx',
  'odt',
  'ppt',
  'pptx',
  'odp',
  'xls',
  'xlsx',
  'ods',
];

export const ACCEPTED_FILES_CONFIG = {
  'image/*': ['.jpg', '.jpeg', '.png', '.gif'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'text/plain': ['.txt'],
  'application/rtf': ['.rtf'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
    '.pptx',
  ],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'application/vnd.oasis.opendocument.presentation': ['.odp'],
  'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
};

export const SUPPORT_CATEGORIES = [
  'Request Support',
  'DCIM',
  'Visualizer',
  'Report a Bug',
  'API Overview & Demo',
  'Business Inquiry',
  'Request Sandbox Access',
  'Request Production Access',
];

export const FILE_VALIDATION_ERRORS = {
  INVALID_FILE: 'Invalid file',
  FILE_TOO_LARGE: 'File size must be less than 33 MB',
  FILE_TYPE_NOT_ALLOWED: 'File type is not allowed. Please try another.',
  TOO_MANY_FILES: `You can upload up to ${MAX_FILES_COUNT} files only.`,
} as const;

export const DCIM_API_URLS = [
  'https://customerapi.interxion.com',
  'https://api.digitalrealty.com',
  'https://opdaas.digitalrealty.com/api/v2',
] as const;
